import { FDRStatus } from '@cibo/core'
import { PaginatedFieldsContext } from '@cibo/landmanager'
import { FriendlyError, ResponsiveDialog } from '@cibo/ui'
import BugReportRounded from '@mui/icons-material/BugReportRounded'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  ButtonProps,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Stack,
  TextField,
} from '@mui/material'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCreateErrorReportAgreement } from './useCreateErrorReportAgreement'

export const GenerateTestAgreementButton = (props: ButtonProps) => {
  const { t } = useTranslation('impact/EnrollSelectedFields')
  const { selectedFields, selectedRowIds } = useContext(PaginatedFieldsContext)
  const [pickerOpen, setPickerOpen] = useState(false)
  const [name, setName] = useState('')

  const createAgreement = useCreateErrorReportAgreement()

  const handleClickGenerate = () => {
    const formData = new FormData()

    formData.append('name', name)
    formData.append('userId', `${selectedFields[0].ownedBy.userId}`)
    formData.append('resourceIds', selectedRowIds.join(','))

    const csvData = 'Name,Age,Location\nJohn,25,New York\nJane,30,Los Angeles'
    const blob = new Blob([csvData], { type: 'text/csv' })
    const file = new File([blob], 'data.csv', { type: 'text/csv' })

    formData.append('file', file)

    createAgreement.mutateAsync(formData).then(() => {
      setPickerOpen(false)
      setName('')
    })
  }

  const canCreateErrorReport =
    selectedFields?.length &&
    selectedFields.every(({ fdrStatus }) =>
      fdrStatus.some(({ status }) => status.includes(FDRStatus.enrolled))
    )

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <LoadingButton
          color="secondary"
          variant="outlined"
          {...props}
          onClick={() => setPickerOpen(true)}
          disabled={!canCreateErrorReport}
          startIcon={<BugReportRounded color="error" />}
        >
          TEST Error Report
        </LoadingButton>
      </Stack>

      <ResponsiveDialog
        fullWidth
        maxWidth="sm"
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
      >
        <DialogTitle>Generate Error Report</DialogTitle>
        <DialogContent>
          {!!createAgreement.error && (
            <FriendlyError message={JSON.stringify(createAgreement.error)} />
          )}

          <FormControl>
            <FormLabel>Name</FormLabel>
            <TextField onChange={event => setName(event.target.value)} value={name} />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPickerOpen(false)}>{t('cancel')}</Button>
          <LoadingButton
            onClick={handleClickGenerate}
            loading={createAgreement.isLoading}
            variant="contained"
            color="secondary"
          >
            Create Agreement
          </LoadingButton>
        </DialogActions>
      </ResponsiveDialog>
    </>
  )
}
